/**
 * @velyn-custom BEGIN — vely-header-sticky.js
 * Hide header on scroll down, reveal on scroll up (Velyn layer; does not change Purity SiteHeader).
 * Toggles classes on the section + html so the visible .header-wrapper slides away.
 * Syncs --vely-header-offset for sticky bars such as vely-quick-access.
 */
(function () {
  const HIDDEN_CLASS = "vely-header--hidden";
  const READY_CLASS = "vely-header--scroll-ready";
  const CORE_HIDDEN_CLASS = "header-sticky-hidden";
  const HTML_HIDDEN_CLASS = "vely-header-is-hidden";
  const OFFSET_VAR = "--vely-header-offset";
  const MIN_DELTA = 8;
  const TOP_SHOW_PX = 12;

  let section = null;
  let lastY = 0;
  let ticking = false;
  let hidden = false;
  let scrollBound = false;

  function getSection() {
    const inner =
      document.querySelector("header[is='site-header']") ||
      document.querySelector("header.header-site") ||
      document.querySelector("header.header-wrapper");

    if (inner) {
      return (
        inner.closest(".shopify-section") ||
        inner.closest(".site-header") ||
        inner
      );
    }

    return (
      document.getElementById("shopify-section-header") ||
      document.querySelector(".shopify-section.site-header") ||
      document.querySelector(".site-header")
    );
  }

  function measureHeight() {
    if (!section) return 0;
    const bar = section.matches("header")
      ? section
      : section.querySelector("header.header-wrapper, .header-wrapper");
    return Math.round((bar || section).offsetHeight) || 0;
  }

  function getScrollY() {
    return (
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    );
  }

  function isUiLocked() {
    const root = document.documentElement;
    if (root.classList.contains("open-modal")) return true;
    if (root.classList.contains("open-modal-account")) return true;
    if (section && section.querySelector(".details-header-menu.detail-open")) return true;
    return false;
  }

  function applyOffset() {
    const offset = hidden ? 0 : measureHeight();
    document.documentElement.style.setProperty(OFFSET_VAR, `${offset}px`);
    return offset;
  }

  function setHidden(nextHidden, force) {
    if (!section) return;
    if (!force && nextHidden === hidden) {
      applyOffset();
      return;
    }

    hidden = nextHidden;
    section.classList.toggle(HIDDEN_CLASS, hidden);
    section.classList.toggle(CORE_HIDDEN_CLASS, hidden);
    document.documentElement.classList.toggle(HTML_HIDDEN_CLASS, hidden);
    const offset = applyOffset();

    window.dispatchEvent(
      new CustomEvent("vely:header-visibility", {
        detail: { hidden, offset },
      }),
    );
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      if (!section) {
        section = getSection();
        if (!section) return;
        section.classList.add(READY_CLASS);
      }

      const y = getScrollY();
      if (y < 0) {
        lastY = 0;
        return;
      }

      if (y <= TOP_SHOW_PX) {
        setHidden(false);
        lastY = y;
        return;
      }

      if (isUiLocked()) {
        lastY = y;
        return;
      }

      const delta = y - lastY;
      if (Math.abs(delta) < MIN_DELTA) return;

      const height = measureHeight();
      if (delta > 0 && y > height) {
        setHidden(true);
      } else if (delta < 0) {
        setHidden(false);
      }

      lastY = y;
    });
  }

  function onResize() {
    applyOffset();
  }

  function bindScroll() {
    if (scrollBound) return;
    window.addEventListener("scroll", onScroll, { passive: true, capture: true });
    window.addEventListener("resize", onResize, { passive: true });
    scrollBound = true;
  }

  function initHeader() {
    section = getSection();
    if (!section) {
      bindScroll();
      return;
    }

    section.classList.add(READY_CLASS);
    lastY = getScrollY();
    hidden = section.classList.contains(HIDDEN_CLASS);
    if (lastY <= TOP_SHOW_PX) {
      setHidden(false, true);
    } else {
      applyOffset();
    }
    bindScroll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const target = event.target;
    if (!target || !target.closest) return;
    if (target.matches(".site-header, .shopify-section.site-header") || target.querySelector("header.header-site")) {
      initHeader();
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeader);
  } else {
    initHeader();
  }
})();
/* @velyn-custom END — vely-header-sticky.js */
